import classNames from 'classnames';
import { Link } from 'wouter';

import Menu from './Menu';

import styles from '../../../styles/menus/columns.module.css';

interface MenuColumn {
    title?: string | null;
    url?: string | null;
    items: any[]; // Menu items array
}

interface ColumnsMenuProps {
    columns: MenuColumn[];
    className?: string | null;
    titleClassName?: string | null;
    colsClassName?: string | null;
    colClassName?: string | null;
    menuClassName?: string | null;
    subItemsClassName?: string | null;
    itemsClassName?: string | null;
    itemClassName?: string | null;
    currentClassName?: string | null;
    spacerClassName?: string | null;
    linkClassName?: string | null;
}

function ColumnsMenu({
    columns,
    className = null,
    titleClassName = null,
    colsClassName = null,
    colClassName = null,
    menuClassName = null,
    subItemsClassName = null,
    itemsClassName = null,
    itemClassName = null,
    currentClassName = null,
    spacerClassName = null,
    linkClassName = null,
}: ColumnsMenuProps) {
    return (
        <div
            className={classNames({
                [styles.container]: true,
                [className]: className !== null,
            })}
        >
            <div
                className={classNames([
                    styles.cols,
                    {
                        [colsClassName]: colsClassName !== null,
                    },
                ])}
            >
                {columns
                    .filter((f) => f !== null)
                    .map(({ title = null, url = null, items = null }, index) => (
                        <div
                            className={classNames([
                                styles.col,
                                {
                                    [colClassName]: colClassName !== null,
                                },
                            ])}
                            key={`col-${title || index}`}
                        >
                            <div className={styles.inner}>
                                {title !== null ? (
                                    <h2
                                        className={classNames([
                                            styles.title,
                                            {
                                                [titleClassName]: titleClassName !== null,
                                            },
                                        ])}
                                    >
                                        {url !== null ? <Link href={url}>{title}</Link> : title}
                                    </h2>
                                ) : null}
                                <div className={styles.menuContainer}>
                                    <Menu
                                        items={items}
                                        className={classNames([
                                            styles.menu,
                                            {
                                                [menuClassName]: menuClassName !== null,
                                            },
                                        ])}
                                        subItemsClassName={classNames([
                                            styles.submenu,
                                            {
                                                [subItemsClassName]: subItemsClassName !== null,
                                            },
                                        ])}
                                        itemsClassName={classNames([
                                            styles.items,
                                            {
                                                [itemsClassName]: itemsClassName !== null,
                                            },
                                        ])}
                                        itemClassName={classNames([
                                            styles.item,
                                            {
                                                [itemClassName]: itemClassName !== null,
                                            },
                                        ])}
                                        spacerClassName={classNames([
                                            styles.spacer,
                                            {
                                                [spacerClassName]: spacerClassName !== null,
                                            },
                                        ])}
                                        linkClassName={classNames([
                                            styles.link,
                                            {
                                                [linkClassName]: linkClassName !== null,
                                            },
                                        ])}
                                        currentClassName={classNames([
                                            styles.current,
                                            {
                                                [currentClassName]: currentClassName !== null,
                                            },
                                        ])}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
}

export default ColumnsMenu;
